import * as React from 'react';
import type { SVGProps } from 'react';
const SvgRotateRightVector = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={174}
    height={311}
    fill="none"
    {...props}
  >
    <path
      stroke="#EEEFFF"
      strokeWidth={3}
      d="M38.105 214.5c3.168 6.167 13.795 28.6 9.395 45s-15.833 38.833-21 48zm0 0L47.5 157m99.104 150.5c1.955-8.632-1.729-43.867-.5-58 1.088-12.5 6.605-79.557 7-92.5M3.105 305.5 2 207c4.418-52.891 3.105-83.704 11.5-90 7.033-5.275 18.995-8.908 31-12.852 6.201-2.216 20.305-7.623 27.104-11.526 3.913-2.595 7.025-5.578 8.896-9.122 9.5-18-6.5-13-5-42S91.5 2 110.999 2c20.5 0 40 13 43 29 2.4 12.8 2.667 20.333 2.5 22.5-1.166.833-3.5 3-3.5 5 0 2.5 5.5 13 4.5 16.5S151 76.5 150 78s.5 4-1 5.5-5 0-5.5 1.5 3 3 1.5 5-4.5 1-5.5 2.5 1.5 3-1.5 7-10.5-.5-16 3.5c-4.4 3.2-2.395 3 5.105 4.5 10 1.5 25 3 32.5 7 3.335 1.779 7.691 10.642 8.5 15.5.5 3 3.999 92 3.999 97-.5 33-2.499 20-5.499 83"
    />
  </svg>
);
export default SvgRotateRightVector;
